<template>
  <v-dialog
      v-model="isOpen"
      max-width="448px"
      persistent
  >
    <v-card :loading="isLoading">
      <v-card-title>
        Renovar contrato de dietista
      </v-card-title>

      <v-divider></v-divider>

      <v-card-subtitle class="pt-5">
        Selecciona la nueva fecha de renovación de contrato del dietista.
      </v-card-subtitle>

      <v-card-text>
        <v-form ref="renovationForm">
          <v-row>
            <v-col cols="12">
              <v-menu
                  ref="dateMenuRef"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  max-width="384px"
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formattedDate"
                      label="Nueva fecha de renovación de contrato"
                      hint="Selecciona la nueva fecha de renovación de contrato del dietista"
                      persistent-hint
                      outlined
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      clearable
                      @click:clear="renovationDate = null"
                      :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="renovationDate"
                    @input="dateMenu = false"
                    locale="es-MX"
                    scrollable
                    first-day-of-week="1"
                    :active-picker.sync="activePicker"
                    :min="tomorrowDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <CancelButton @click="handleClose" :isLoading="isLoading"/>
        <v-spacer></v-spacer>
        <SaveButton @click="updateRenovationDate" :isLoading="isLoading"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import CancelButton from "@/components/buttons/CancelButton.vue";
import SaveButton from "@/components/buttons/SaveButton.vue";
import UserService from "@/services/users/UserService";
import SuccessMessage from "@/utils/SuccessMessage";
import throwSuccessMessage from "@/utils/SuccessMessage";

export default Vue.extend({
  name: "DialogRenovation",
  components: {SaveButton, CancelButton},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    username: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // Date picker
      dateMenu: false as boolean,
      renovationDate: "" as string,
      activePicker: 'MONTH' as 'YEAR' | 'MONTH' | 'DATE',

      // State
      isLoading: false as boolean,

      // Validation
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
      }
    };
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.value;
      },
    },
    formattedDate(): string | null {
      if (!this.renovationDate) return null;
      return this.formatDate(this.renovationDate);
    },
    tomorrowDate(): string {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const day = String(tomorrow.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }
  },
  methods: {
    async updateRenovationDate() {
      this.isLoading = true;
      try {
        const body = {
          username: this.username,
          renovationDate: this.renovationDate,
        }
        await UserService.updateRenovationDate(body);
        throwSuccessMessage("Fecha de renovación de contrato actualizada exitosamente");
        this.$emit("updated")
        this.handleClose();
      } finally {
        this.isLoading = false;
      }
    },
    handleClose() {
      this.renovationDate = "";
      const form = this.$refs.renovationForm as any;
      form.resetValidation();
      this.$emit("input", false);
    },
    formatDate(date: string): string | null {
      const [year, month, day] = date.split("-").map(Number);
      const formatted = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Intl.DateTimeFormat('es-MX', options).format(formatted);
    }
  },
})
</script>

<style scoped>

</style>